import { createContext, useContext } from 'react';

/** Layer keys the operator has switched off. Missing means visible. */
export const MapLayerHiddenContext = createContext<Record<string, boolean>>({});

export function useMapLayerVisible(key: string): boolean {
  return !useContext(MapLayerHiddenContext)[key];
}

/** Icon chips on pins vs place names on the basemap. Independent on purpose. */
export type MapLabelVisibility = { icons: boolean; map: boolean };

export const MapLabelVisibilityContext = createContext<MapLabelVisibility>({
  icons: true,
  map: true,
});

export function useMapIconLabels(): boolean {
  return useContext(MapLabelVisibilityContext).icons;
}
